/**
 * Largest Azure DevOps work item id a ticket can hold:
 * `tickets.ado_work_item_id` is a PostgreSQL INTEGER.
 */
export const TICKET_ADO_WORK_ITEM_ID_MAX = 2_147_483_647;

/**
 * Names of the file parts of the multipart ticket requests. The text fields
 * are the command DTOs (`CreateTicketCommandDto`, `AddTicketCommentCommandDto`);
 * the files travel next to them under these names and never inside a DTO.
 *
 * - Create a ticket: `CONTEXT` (one JSON file), `SCREENSHOT` (optional, one
 *   image) and `ATTACHMENTS` (optional, repeated).
 * - Add a conversation message, customer or team: `ATTACHMENTS` only.
 */
export const TICKET_UPLOAD_FIELDS = {
  CONTEXT: 'context',
  SCREENSHOT: 'screenshot',
  ATTACHMENTS: 'attachments',
} as const;

export type TicketUploadField =
  (typeof TICKET_UPLOAD_FIELDS)[keyof typeof TICKET_UPLOAD_FIELDS];
